import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';

import { FiltroConcurso } from './filtro';
import { Subscription } from 'rxjs';
import { ValidateHelper } from '@core/helpers/validate.helper';

@Component({
	selector: 'sgp-manter-concurso',
	templateUrl: './manter-concurso.component.html'
})
export class ManterConcursoComponent implements  AfterViewInit , OnDestroy {
	@Input() item!: FiltroConcurso;
	@Input() tabela = '';
	@Input() exibirCadastradoPeloUsuario!: boolean;
	@Input() exibirFerramenta = false;
	@Output() itemSalvo: EventEmitter<FiltroConcurso> = new EventEmitter<FiltroConcurso>();
	@Output() fecharModal: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild('elNomeCampo') elNomeCampo!: ElementRef;
	erroNome = false;
	mensagemErroNome = '';
	desabilitar = true;
	submetido = false;
	subscriptions: Subscription[] = [];
	
	constructor(private validate: ValidateHelper) {}

	ngAfterViewInit(): void {
		this.elNomeCampo.nativeElement.focus();
	}

	salvar() {
		this.submetido = true;
		this.validarPreenchimentoNome();
		if (!this.erroNome) {
			this.itemSalvo.emit(this.item);
			this.submetido = false;
		}
	}

	cancelar() {
		this.item = new FiltroConcurso();
		this.submetido = false;
		this.erroNome = false;
		this.fecharModal.emit(true);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

	validarPreenchimentoNome() {
		const nomeTrim = this.item.nome?.trim();
		if (this.validate.isEmBranco(nomeTrim)) {
			this.erroNome = true;
			this.mensagemErroNome = 'Campo obrigatório';
		} else if (nomeTrim && nomeTrim.length < 3) {
			this.erroNome = true;
			this.mensagemErroNome = 'O campo deve possuir pelo menos três caracteres';
		} else {
			this.item.nome = nomeTrim;
			this.erroNome = false;
		}
	}

}
